import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}')({
  beforeLoad: () => getTitleContextSlice('Rule Set'),
});
